import useSetOrderAsDelivered from "api/OrderResource/useSerOrderAsDelivered";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { BiChevronRight } from "react-icons/bi";

/**
 * @param {Object} props
 * @param {string} props.orderId
 * @param {Function} props.onSuccess
 * @returns {JSX.Element}
 */
const SetOrderAsDelivered = (props) => {
	const { orderId, onSuccess } = props;

	const { mutateAsync: setAsDelivered, isLoading } =
		useSetOrderAsDelivered(orderId);

	const handleSetAsDelivered = async () => {
		if (
			window.confirm("Are you sure you want to mark this order as delivered?")
		) {
			try {
				await setAsDelivered();
				onSuccess();
			} catch (error) {
				// console.log(error);
			}
		}
	};

	return (
		<button
			onClick={handleSetAsDelivered}
			disabled={isLoading}
			className="bg-green-600 hover:bg-green-700 disabled:bg-green-400 text-white px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 flex items-center gap-1"
		>
			Mark as delivered
			{isLoading ? (
				<AiOutlineLoading3Quarters
					className="animate-spin"
					size={20}
				/>
			) : (
				<BiChevronRight size={20} />
			)}
		</button>
	);
};

export default SetOrderAsDelivered;
